export default "__VITE_ASSET__Bty_0W5L__"